"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCommand = void 0;
class SearchCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { contents, customer, search_string } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('browsing', 'product_search', {
            items: contents?.map((content) => ({
                id: content?.content_data?.sku ?? 'no-id-view-content',
                name: content?.content_data?.name ?? 'no-name-view-content',
                type: 'product',
            })) ?? [],
            ...(customer && {
                dims: {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                },
            }),
            extra: {
                src_search_term: search_string,
            },
        });
        return Promise.resolve();
    }
}
exports.SearchCommand = SearchCommand;
